import { configureSync, getConsoleSink } from "@logtape/logtape";
import { loggers } from "~/lib/logtape-config";
import { getRumSink } from "~/lib/logtape-rum-sink";

configureSync({
  reset: true,
  sinks: {
    console: getConsoleSink(),
    event: getRumSink(),
  },
  loggers,
});
